'use client';

import { useRouter } from 'next/navigation';
import { generateRoomId } from '@/lib/client-utils';
import styles from '../styles/Home.module.css';

export default function Page() {
  const router = useRouter();

  const startMeeting = () => {
    router.push(`/rooms/${generateRoomId()}`);
  };

  return (
    <main className={`${styles.main} bg-[#1a1a1a] min-h-screen`} data-lk-theme="default">
      <button
        onClick={startMeeting}
        className="w-48 px-4 py-1.5 text-sm rounded-full font-medium transition-colors"
        style={{ backgroundColor: '#ffffff', color: '#1a1a1a' }}
      >
        Start call
      </button>
    </main>
  );
}
